import React, { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { purifier, addEvent, removeEvent } from '../../../utils/dom';
import { imageSizeTranslation } from '../../../utils/image';
import { prefix, translate } from '../../../utils/locale';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Image.scss';

const Image = ({ content, attrs, setup, column = 'full', extraProps = null, imageWidth = false, lazyLoad }) => {
	let Wrapper = ({ children }) => (
		<a href="#open-lightbox" onClick={openLightboxHandler}>
			{ children }
		</a>
	);
	const [showingLightbox, toggleLightbox] = useState(false);

	useEffect(() => {
		addEvent(document.body, 'keydown.lightbox', (e) => {
			if (e.key === 'Escape') {
				toggleLightbox(false);
			}
		});

		return () => {
			removeEvent(document.body, 'keydown.lightbox');
		};
	});

	const openLightboxHandler = (e) => {
		e.preventDefault();
		toggleLightbox(true);
	};

	const closeLightboxHandler = (e) => {
		e.preventDefault();
		toggleLightbox(false);
	};

	if (attrs?.href) {
		const externalLink = /^(https?|mailto|tel)/.test(attrs.href);
		const anchorLink = /^#/.test(attrs.href);

		if (attrs.target || externalLink || anchorLink) {
			Wrapper = ({ children }) => (
				<a href={attrs.href} target="_blank" rel="noopener noreferrer">
					{ children }
				</a>
			);
		} else {
			Wrapper = ({ children }) => (
				<Link to={prefix(setup, cleanInternalLinks(attrs.href))}>
					{ children }
				</Link>
			);
		}
	}

	return (
		<>
			{
				showingLightbox && (
					<figure className={[s.imageLightbox, (content.image.width < content.image.height ? s.imageLightbox__portrait : null)].join(' ')}>
						<a className={s.imageLightbox_close} href="#close-overlay" onClick={closeLightboxHandler}><span>{ `< ${translate(setup, 'back')}` }</span></a>
						{ content.image.url && <LazyImage {...imageSizeTranslation('12', content.image, '-', false, false)} className={[s.imageLightbox_image]} {...extraProps} /> }
						{ content.image.description && <figcaption className={s.imageLightbox_description} dangerouslySetInnerHTML={{ __html: purifier(content.image.description) }} /> }
					</figure>
				)
			}
			<Wrapper>
				<figure className={[s.image, (showingLightbox ? s.image__lightbox : null), (content.image.width < content.image.height ? s.image__portrait : null)].join(' ')}>
					{ content.image.url && <LazyImage {...imageSizeTranslation(column, content.image, '-', lazyLoad, false)} className={[s.image_image, 'js-lazyLoad']} {...extraProps} /> }
					{ content.caption && <figcaption className={s.image_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
				</figure>
			</Wrapper>
		</>
	);
};

export default hot(module)(Image);
